'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './checkout-header.component';
import dynamic from 'next/dynamic';

const DynamicCheckoutHeaderComponent: ComponentType<Props> = dynamic(
  () => import('./checkout-header.component')
);

export default DynamicCheckoutHeaderComponent;

export function calculateCheckoutHeaderPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [{ sinceWidth: 0, height: 72.65 }];

  return {
    heightSinceWidth
  };
}
